import { createMuiTheme } from '@material-ui/core/styles';

export default function GetAppTheme() {

  const theme = createMuiTheme({
    typography: {
      fontFamily: ['Google Sans Regular', 'Roboto'].join(','),
    },
    palette: {
      background: {
        default: '#000000',
      },
      primary: {
        main: '#5B92E5',
      },
      secondary: {
        main: '#ffffff',
      },
    },
    overrides: {
      MuiAppBar: {
        root: {
          background: '#fff',
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: 'rgba(0,0,0,0)',
        },
      },

      MuiTooltip: {
        tooltip: {
          fontSize: "11px",
          color: "black",
          backgroundColor: "white"
        }
      },
      MuiSelect: {
        select: {
          '&:focus': {
            background: '#fff',
          },
        },
      },
    },
  });
  return theme;
}